<template>


  <div class='myTile'>
    <p class='title is-3 is-6-mobile'>comments can kill</p>
    <div class='has-text-left'>
      <p>Over <span class='myNumber'>{{ pctDirectInfections }}</span> of infections happened from direct contact (i.e., replying to the comment of an already-infected user).</p>
      <br>
      <p class='chartTitle'>Figure 4:  Infections by cause</p>
      <hr class='rule'>
    </div>

    <div>
      <div v-if="mobile" class='has-text-left'>
        <ul class='legendList'>
          <li class='myNumber is-size-6'>{{ infectionPieChart[1][0] }}</li>
          <li class='userName is-size-6'>{{ infectionPieChart[2][0] }}</li>
        </ul>
      </div>
      <GChart
        type="PieChart"
        :data="infectionPieChart"
        :options="{
            pieHole: .6, 
            backgroundColor: '#F0F0F0', 
            chartArea: {backgroundColor: '#F0F0F0', height: 150, width: '100%'},
            colors: ['#3298DC', '#F14668'],
            legend: responsivePieChartLegend,
            pieSliceText: 'none',
          }"
      ></GChart>
    </div>
  </div>


</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  props: ['mobile'],
  data() {
    return {
      pctDirectInfections: '98%',
      infectionPieChart: [
        ['source of infection', 'infections'],
        ["replying to infected comments", 124376],
        ['commenting on infected posts', 2475]
      ],
    }
  },
  computed: {
    responsivePieChartLegend() {
      let desktopLegend = {
        alignment: 'center',
        position: 'labeled',
        textStyle: {fontSize: 14}
      };
      let mobileLegend = {
        position: 'none'
      };
      return this.mobile ? mobileLegend : desktopLegend;
    },
  },
  components: {
    GChart
  }
}


</script>